import { FiCheck } from '@react-icons/all-files/fi/FiCheck';
import { FiMail } from '@react-icons/all-files/fi/FiMail';
import React, { useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import { createInStockNotification } from '~graphql/mutations';
import { authUserSelector } from '~redux/auth/selectors/authUser';
import { Product } from '~types/api';
import { executeQuery } from '~utils/graphql';
import { useSelectInventoriesByProduct } from '~view/hooks/inventory';

const SubscribeButton: React.FC<{
  product: Product;
  cart?: boolean;
}> = ({ product, cart }) => {
  const user = useSelector(authUserSelector);
  const inventories = useSelectInventoriesByProduct(product.id!);
  const outOfStocks = useMemo(
    () =>
      Object.values(inventories).filter((inventory) => inventory.isOutOfStock),
    [inventories]
  );

  const [isSubscribed, setSubscribed] = useState(false);
  const handleSubscribe = useCallback(() => {
    if (!user) {
      return;
    }
    outOfStocks.map((inventory) =>
      executeQuery(createInStockNotification, {
        input: {
          brand_id: product.product_brand_id,
          buyer_id: user.attributes.sub,
          product_id: product.id,
          product_type_id: inventory.product_type_id,
          completed: false,
        },
      })
    );
    setSubscribed(true);
  }, [user, outOfStocks.length]);

  if (cart || !outOfStocks?.length || product.product_preorder === 1) {
    return null;
  }

  return (
    <Button
      type="button"
      block
      disabled={isSubscribed}
      onClick={handleSubscribe}
    >
      {isSubscribed && <FiCheck className="mr-2" />}
      {!isSubscribed && <FiMail className="mr-2" />}
      売り切れ商品の再入荷通知を受け取る
    </Button>
  );
};

export default SubscribeButton;
